import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { FormGroup, H4, InputGroup } from '@blueprintjs/core';
import produce from 'utils/produce';
import nanoid from 'utils/nanoid';
import useModalContext from 'components/context/modal';

import EditPersonModal from './editPersonModal';
import treesApi from '../../api/trees';

const NewFamilyModal = forwardRef((props, ref) => {
  const [family, setFamily] = useState({});
  const [person, setPerson] = useState({
    id: `_${nanoid().substring(0, 4).toLowerCase()}`,
  });

  const update = (key, value) => {
    setFamily(val =>
      produce(val, draft => {
        draft[key] = value;
      }),
    );
  };

  useEffect(() => {
    ref.current = {
      family,
      person,
    };
  }, [family, person]);

  return (
    <>
      <H4>Family Tree</H4>
      <FormGroup labelFor="familyCaption" label="Name of your new family tree">
        <InputGroup
          id="familyCaption"
          placeholder="Enter the name of your tree"
          value={family.name}
          onChange={e => update('caption', e.target.value)}
        />
      </FormGroup>

      <H4 className="mt-5">Add Starting Person</H4>

      <EditPersonModal type="create" person={person} onChange={setPerson} />
    </>
  );
});

export const useNewFamilyTreeModal = accessToken => {
  const modalContext = useModalContext();
  const newFamilyRef = useRef();

  return {
    open: (onSuccess = () => {}, onError = () => {}) => {
      modalContext.confirm(<NewFamilyModal ref={newFamilyRef} />, {
        title: 'Create a New Family Tree',
        confirmLabel: 'Start a new tree',
        className: 'mw-660',
        onConfirm: async () => {
          const { family, person } = newFamilyRef.current;

          const api = treesApi(accessToken);

          const { data: treeData, error: treeError } = await api.createTree(family.caption);
          if (treeError) {
            onError(treeError);
            return;
          }

          const { error: personError } = await api.updateTreePersons(treeData.id, [person]);
          if (personError) {
            onError(personError);
            return;
          }

          onSuccess(treeData);

          try {
            gtag('event', 'tree_create', {
              event_category: 'trees',
              event_label: treeData.id,
            });
          } catch (e) {}
        },
      });
    },
  };
};

export default NewFamilyModal;
